export default "__VITE_ASSET__M7jIUuQY__"